import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';

export const TrackingContext = createContext();

export function TrackingContextProvider({ children }) {
    const { user } = useContext(CommonContext);
    const [addModal, setAddModal] = useState(false);
    const [allData, setAllData] = useState([]);
    const [viewData, setViewData] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [allTracking, setAllTracking] = useState([]);
    const [firstLoading, setFirstLoading] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [alertMesaage, setAlertMesaage] = useState('');
    const [severity, setSeverity] = useState('');

    const onCloseAlert = () => {
        setOpenAlert(false);
        setAlertMesaage('');
        setSeverity('')
    };

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setViewData('');
        setAddModal(false);
    };

    const onLoadApi = () => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id }
        } else{
            postReq = { admin_id: user?.id }
        }
        setFirstLoading(false);
        commonApi.post('/tracking-events/list', postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllTracking(response?.data?.data);
                    setAllData(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    useEffect(() => {
        onLoadApi();
    }, []);

    // You can provide any values or functions you want to make available to consumers here
    const contextValue = {
        onCloseAlert,
        severity,
        alertMesaage,
        openAlert,
        onLoadApi,
        firstLoading,
        isLoading,
        viewData,
        allTracking,
        allData,
        handleAddModal,
        handleCloseModal,
        setAddModal,
        addModal,
        setAllData,
        setAllTracking,
        setViewData,
        setIsLoading,
        setFirstLoading,
        setSeverity,
        setAlertMesaage,
        setOpenAlert,
    };

    // Render the provider with children
    return <TrackingContext.Provider value={contextValue}>{children}</TrackingContext.Provider>;
}
